/**
 * Admin container
 */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actions } from './slice';
import appActions from '../App/actions';
import { currentUserSelector } from '../App/selectors';
import { teamSelector } from './selectors';

import SocialMediaDashboard from '../../Components/SocialMediaDashboard/SocialMediaDashboard';
import { influencersExport } from '../../Lib/Utils/Table/table-export';

/**
 * Admin properties to be provided to the admin console component

 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  team: teamSelector(state),
  currentUser: currentUserSelector(state),
});

/**
 * Actions to be dispatched
 *
 * @param {function} dispatch function to dispatch admin actions
 */
const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(appActions.logout()),
  getTeam: () => dispatch(actions.getTeam()),
});

/**
 * Connects admin state to the Admin Console component

 * @param {object} mapStateToProps admin data object to become props for the Admin component
 * @param {object} mapDispatchToProps admin actions to be dispatched to reducer
 */
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )((props) => (
    <SocialMediaDashboard {...props} exportInfluencers={influencersExport} />
  )),
);
